// 1 Jan, 2023
export const ACCOUNT_SETUP_MIN_DATE = new Date(2023, 0, 1);

// Dec 1, 2024
export const REVIEW_CBSA_PREFERENCES_MIN_DATE = new Date(2024, 11, 1);
